import { Modal, Text } from '@bfe/moly';
import { useEffect, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { useUserStore } from '@/store/useUser';
import { complianceExtData } from '@/utils/complianceHelpers';

const CurrencyOfflineModal = ({ code }: { code: string }) => {
  const [$t] = useI18nContext();
  const [showModal, setShowModal] = useState(false);
  const { complianceConfig } = useUserStore();

  useEffect(() => {
    if (code) {
      const key = `alertCurrencyOfflineTime_${code}`;
      const alertUserCurrencyOfflineTime = localStorage.getItem(key) || 0;
      if (+alertUserCurrencyOfflineTime >= 3) {
        return;
      }
      localStorage.setItem(key, `${+alertUserCurrencyOfflineTime + 1}`);
      setShowModal(true);
    }
  }, [code]);

  const onHandleOfflineOk = () => {
    const key = `alertCurrencyOfflineTime_${code}`;
    localStorage.setItem(key, '3');
    setShowModal(false);
  };

  const replaceDefaultCurrency = () => {
    const text = $t('currencyOfflineModalTitle');
    let defaultCurrency = code;
    try {
      defaultCurrency = complianceExtData(
        complianceConfig?.DefaultCurrency,
      )?.default;
    } catch (error) {
      /* empty */
    }
    return text.replace('{{coin}}', defaultCurrency || code);
  };

  return (
    <Modal
      title={false}
      onOk={onHandleOfflineOk}
      open={showModal}
      closable={false}
      className="my-btn"
      cancelText={false}
      okText={$t('Confirm')}
    >
      <Text size={16}>{replaceDefaultCurrency()}</Text>
    </Modal>
  );
};

export default CurrencyOfflineModal;
